<div role="contentinfo" class="footer text-white text-center">
  <!--Sponsors-->
  <div class="footer-primary">
    <hr class="text-secondary" />
    <h5 class="font-size-14">{{ 'footer.club.partners' | translate }}</h5>
    <hr class="text-secondary" />
  </div>

  <a href="{{ 'footer.amex.url' | translate }}">
    <img alt="" class="amex-logo mb-2" src="assets/images/footer/amex.png" draggable="false" />
  </a>

  <div class="footer-second-row">
    <a href="{{ 'footer.nike.url' | translate }}">
      <img alt="" class="nike-logo mb-2" src="assets/images/footer/nike.png" draggable="false" />
    </a>
    <a href="{{ 'footer.kissimmee.url' | translate }}">
      <img alt="" class="kiss-logo mb-2" src="assets/images/footer/kissimmee.png" draggable="false" />
    </a>
  </div>

  <ng-container *inPopulation="[populations.Default, populations.Club1901]">
    <!--Social Icons-->
    <div class="footer-primary">
      <hr class="text-secondary" />
      <h5 class="font-size-14">{{ 'footer.club.socials' | translate }}</h5>
      <hr class="text-secondary" />
    </div>

    <div class="footer-socials">
      <div class="club-socials">
        <h4 class="font-size-14 text-capitalize">{{ 'footer.club.socials.club' | translate }}</h4>
        <a href="{{ 'footer.club.facebook.url' | translate }}">
          <img alt="" class="socials-icon" src="assets/images/footer/socials/facebook.png" draggable="false" />
        </a>
        <a href="{{ 'footer.club.youtube.url' | translate }}">
          <img alt="" class="socials-icon" src="assets/images/footer/socials/youtube.png" draggable="false" />
        </a>
        <a href="{{ 'footer.club.whatsapp.url' | translate }}">
          <img alt="" class="socials-icon" src="assets/images/footer/socials/whatsapp.png" draggable="false" />
        </a>
      </div>

      <div class="club-socials">
        <h4 class="font-size-14 text-capitalize">{{ 'footer.club.socials.men' | translate }}</h4>
        <a href="{{ 'footer.mens.twitter.url' | translate }}">
          <img alt="" class="socials-icon" src="assets/images/footer/socials/twitter.png" draggable="false" />
        </a>
        <a href="{{ 'footer.mens.instagram.url' | translate }}">
          <img alt="" class="socials-icon" src="assets/images/footer/socials/instagram.png" draggable="false" />
        </a>
        <a href="{{ 'footer.mens.threads.url' | translate }}">
          <img alt="" class="socials-icon" src="assets/images/footer/socials/threads.png" draggable="false" />
        </a>
        <a href="{{ 'footer.mens.tiktok.url' | translate }}">
          <img alt="" class="socials-icon" src="assets/images/footer/socials/tiktok.png" draggable="false" />
        </a>
      </div>

      <div class="club-socials">
        <h4 class="font-size-14 text-capitalize">{{ 'footer.club.socials.women' | translate }}</h4>
        <a href="{{ 'footer.womens.twitter.url' | translate }}">
          <img alt="" class="socials-icon" src="assets/images/footer/socials/twitter.png" draggable="false" />
        </a>
        <a href="{{ 'footer.womens.instagram.url' | translate }}">
          <img alt="" class="socials-icon" src="assets/images/footer/socials/instagram.png" draggable="false" />
        </a>
        <a href="{{ 'footer.womens.threads.url' | translate }}">
          <img alt="" class="socials-icon" src="assets/images/footer/socials/threads.png" draggable="false" />
        </a>
        <a href="{{ 'footer.womens.tiktok.url' | translate }}">
          <img alt="" class="socials-icon" src="assets/images/footer/socials/tiktok.png" draggable="false" />
        </a>
      </div>
    </div>

    <!--App Icons-->
    <div class="footer-app-icons">
      <a href="{{ 'footer.android.url' | translate }}">
        <img alt="" class="app-icon" src="assets/images/footer/apps/android.png" draggable="false" />
      </a>
      <a href="{{ 'footer.apple.url' | translate }}">
        <img alt="" class="app-icon" src="assets/images/footer/apps/apple.png" draggable="false" />
      </a>
    </div>

    <hr class="text-secondary footer-divider-bottom mt-0" />
  </ng-container>
</div>
